import axios from "axios";
import { createContext, useState } from "react";
import { BaseUrl } from "../API/Url";
import { useCookies } from "react-cookie";

export const LocationContext = createContext();


export default function UserProvider({ children }) {

    const [Location, setLocation] = useState("");
    const [UserCart, setUserCart] = useState(0);
    const [Cookies] = useCookies(['token']);
    const [SearchShow, setSearchShow] = useState(false)
    const [Role, setRole] = useState("");

    const CheckForLength = async (UserId) => {
        await axios.get(`${BaseUrl}/Cart/CartCheck/${UserId}`, {
            headers: {
                token: Cookies.token && Cookies.token
            }
        }).then((res) => {

            if (res.data.status) {
                setUserCart(res.data?.CartLength);
            }
        })
    }


    return <LocationContext.Provider value={{
        Location, setLocation, UserCart, setUserCart, CheckForLength,
        Role, setRole, SearchShow, setSearchShow
    }}>
        {children}
    </LocationContext.Provider>
}